module.exports = __webpack_public_path__ + "794fe6b15bba9c95b8c8ab959dcb6fc4.mp3";